import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { Field, useBusy } from "../components/common";

export default function ForcePasswordChange() {
  const { reload, logout } = useAuth();
  const { t, lang, setLang } = useLang();
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, run] = useBusy();
  const set = (k) => (e) => setPw({ ...pw, [k]: e.target.value });
  const submit = (e) =>
    run(async () => {
      e.preventDefault();
      if (pw.new_password !== pw.confirm) return toast.error(t("Passwords do not match", "Las contraseñas no coinciden"));
      try {
        await api.post("/auth/password", { current_password: pw.current_password, new_password: pw.new_password });
        toast.success(t("Password changed", "Contraseña cambiada"));
        await reload();
      } catch (err) {
        toast.error(errMsg(err));
      }
    });
  return (
    <div className="min-h-screen flex flex-col justify-center px-6 py-10 sm:px-16 max-w-lg mx-auto" data-testid="force-password-page">
      <div className="flex justify-between items-center mb-8">
        <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#D9531E] text-white font-extrabold text-lg">HC</span>
        <button className="btn-outline btn-sm" onClick={() => setLang(lang === "en" ? "es" : "en", false)} data-testid="force-password-lang-toggle">
          {lang === "en" ? "Español" : "English"}
        </button>
      </div>
      <h1 className="text-3xl font-extrabold text-slate-900">{t("Create a new password", "Crea una nueva contraseña")}</h1>
      <p className="mt-2 text-slate-600" data-testid="force-password-message">
        {t("For security, you must replace the default password before using the app.", "Por seguridad, debes reemplazar la contraseña predeterminada antes de usar la app.")}
      </p>
      <form onSubmit={submit} className="mt-6 grid gap-4">
        <Field label={t("Current password", "Contraseña actual")}><input className="inp" type="password" required autoComplete="current-password" value={pw.current_password} onChange={set("current_password")} data-testid="force-current-password" /></Field>
        <Field label={t("New password (min 8)", "Nueva contraseña (mín 8)")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.new_password} onChange={set("new_password")} data-testid="force-new-password" /></Field>
        <Field label={t("Confirm new password", "Confirmar nueva contraseña")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.confirm} onChange={set("confirm")} data-testid="force-confirm-password" /></Field>
        <button className="btn-primary" disabled={busy} data-testid="force-password-submit">{t("Save new password", "Guardar nueva contraseña")}</button>
        <button type="button" className="btn-outline" onClick={logout} data-testid="force-password-logout">{t("Sign out", "Cerrar sesión")}</button>
      </form>
    </div>
  );
}
